import { userModel } from '@/models/api/user.model';
import { sportClubBoardTypeModel } from '@/models/api/sportClubBoardType.model';

export const sportClubBoardModel = (data = {}) => ({
    uuid: data.uuid,
    isActive: Number(data.is_active),
    user: data.ihextar_user ? userModel(data.ihextar_user) : null,
    boardType: data.board_type ? sportClubBoardTypeModel(data.board_type) : null,
    sportClub: data.sport_club || null,
    createdAt: data.created_at || null,
    createdBy: data.created_by || null,
    updatedAt: data.updated_at || null,
    updatedBy: data.updated_by || null,
    deletedAt: data.deleted_at || null,
    deletedBy: data.deleted_by || null,
});
